<ng-container *ngIf="name">
    <ng-container *ngIf="name | dsIsRegisteredIcon; else fontIcon">
        <mat-icon
            class="ds-icon"
            [ngClass]="['ds-icon--size-' + size, 'ds-icon--theme-' + theme]"
            [style.color]="color"
            [style.font-size]="iconSize"
            [style.width]="iconSize"
            [style.height]="iconSize"
            [svgIcon]="name"
            [attr.aria-hidden]="ariaLabel ? null : true"
            [attr.aria-label]="ariaLabel"
        ></mat-icon>
    </ng-container>
</ng-container>

<ng-template #fontIcon>
    <mat-icon
        class="ds-icon"
        [ngClass]="['ds-icon--size-' + size, 'ds-icon--theme-' + theme]"
        [style.color]="color"
        [style.font-size]="iconSize"
        [style.width]="iconSize"
        [style.height]="iconSize"
        [fontSet]="fontSet"
        [attr.aria-hidden]="ariaLabel ? null : true"
        [attr.aria-label]="ariaLabel"
    >
        {{ name }}
    </mat-icon>
</ng-template>
